import { graphql } from '@/graphql-setup'

export const SIDEBAR_QUERY = graphql(`
  query Sidebar(
    $filterStartDate: DateTime!
    $workPeriodStartDate: DateTime!
    $filterEndDate: DateTime!
    $user: ID!
  ) {
    allIssues(closedAt_Isnull: true, archivedAt_Isnull: true) {
      total
    }
    allAbsences(requestStatus: "pending", datetimeStart_Gte: $filterStartDate) {
      total
    }
    allWorkPeriods(
      user: $user
      datetimeStart: $workPeriodStartDate
      datetimeEnd: $filterEndDate
    ) {
      total
    }
    allFormTemplates(excludeArchived: true, onlyMenuShortcuts: true) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`)
